import { Link } from "react-router-dom";

export default function CategoryEntry() {
  return (
    <section className="container-portal mt-10">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <Link
          to="/category/movie"
          className="group relative flex h-[170px] items-end overflow-hidden rounded-lg md:h-[190px] cursor-pointer"
        >
          <img
            src="https://readdy.ai/api/search-image?query=cinematic%20wide%20ancient%20chinese%20palace%20rooftops%20at%20dusk%20with%20warm%20lanterns%20and%20drifting%20mist%20deep%20navy%20sky%20and%20amber%20light%20painterly%20atmosphere%20no%20text%20high%20detail&width=1000&height=500&seq=rs-entry-movie&orientation=landscape"
            alt="电影分类入口"
            title="电影 - 人兽影视网"
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-950/92 via-primary-900/70 to-primary-900/25" />
          <div className="relative flex w-full items-end justify-between p-5 md:p-6">
            <div>
              <span className="label-caps text-[10px] text-accent-300">Movies</span>
              <h2 className="mt-1.5 text-xl font-bold text-background-50 md:text-2xl">电影</h2>
              <p className="mt-1 text-xs text-background-200/80">院线新片 · 类型佳作 · 影展选片</p>
            </div>
            <span className="flex h-9 w-9 items-center justify-center rounded-full border border-background-50/30 text-background-50 transition-colors group-hover:border-accent-400 group-hover:bg-accent-500">
              <i className="ri-arrow-right-up-line" />
            </span>
          </div>
        </Link>

        <Link
          to="/category/tv"
          className="group relative flex h-[170px] items-end overflow-hidden rounded-lg md:h-[190px] cursor-pointer"
        >
          <img
            src="https://readdy.ai/api/search-image?query=cinematic%20wide%20view%20of%20a%20narrow%20old%20city%20alley%20at%20evening%20with%20warm%20window%20lights%20hanging%20laundry%20and%20bicycles%20deep%20navy%20shadows%20and%20amber%20glow%20nostalgic%20quiet%20atmosphere%20no%20text%20high%20detail&width=1000&height=500&seq=rs-entry-tv&orientation=landscape"
            alt="电视剧分类入口"
            title="电视剧 - 人兽影视网"
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/92 via-foreground-900/70 to-foreground-900/25" />
          <div className="relative flex w-full items-end justify-between p-5 md:p-6">
            <div>
              <span className="label-caps text-[10px] text-accent-300">Series</span>
              <h2 className="mt-1.5 text-xl font-bold text-background-50 md:text-2xl">电视剧</h2>
              <p className="mt-1 text-xs text-background-200/80">热播剧集 · 口碑长剧 · 海外限定</p>
            </div>
            <span className="flex h-9 w-9 items-center justify-center rounded-full border border-background-50/30 text-background-50 transition-colors group-hover:border-accent-400 group-hover:bg-accent-500">
              <i className="ri-arrow-right-up-line" />
            </span>
          </div>
        </Link>
      </div>
    </section>
  );
}